const countdown = document.querySelector('.countdown'),
  reproductor = document.querySelector('.reproductor'),
  formulario = document.getElementById('formulario'),
  boton = document.getElementById('boton'),
  radioButtons = document.querySelectorAll('input[name="respuesta"]'),
  preguntaConfirmacion = document.getElementById('preguntaConfirmacion'),
  aceptaConfirmacion = document.getElementById('aceptaConfirmacion'),
  rechazaConfirmacion = document.getElementById('rechazaConfirmacion'),
  asistentes = document.getElementById('asistentes'),
  formText = document.querySelector('.form-text'),
  token = document.getElementById('token').value,
  numeroMesa = document.getElementById('numero_mesa').value,
  paquete = document.getElementById('paquete').value,
  desbloquear = document.getElementById('desbloquear'),
  documento = document.querySelector('.documento'),
  bienvenida = document.querySelector('.bienvenida '),
  audio = document.getElementById('audio'),
  agendar1 = document.querySelector('.agendar1'),
  agendar2 = document.querySelector('.agendar2');

if (asistentes) {
  const valueAsistentes = asistentes.options[asistentes.selectedIndex];
}

let ubicacionPrincipal = window.pageYOffset;

document.addEventListener('DOMContentLoaded', function () {
  inicarApp();
});

// window.addEventListener('resize', function () {
//   // tu código aquí
//   console.log('La resolución de tu pantalla es: ' + document.documentElement.clientWidth + ' x ' + document.documentElement.clientHeight);
// });

function inicarApp() {
  bloquearScroll();
  esconderHeader();
  aparecerElementos();
  if (asistentes) {
    desplegarCantidadPersonas();
  }
  validarFormulario();
  botonCalendario1();
  botonCalendario2();
}

function aparecerElementos() {
  ScrollReveal().reveal('.portada__text', { delay: 300 });
  ScrollReveal().reveal('.legend', { delay: 300 });
  ScrollReveal().reveal('.imagen-padres', { delay: 300 });
  ScrollReveal().reveal('.portada2__p p', { delay: 300 });
  ScrollReveal().reveal('.ubicacion img', { delay: 300 });
  ScrollReveal().reveal('.discurso-descripcion-texto', { delay: 300 });
  ScrollReveal().reveal('.recepcion-descripcion-texto', { delay: 300 });
  ScrollReveal().reveal('.vestimenta__imagenes', { delay: 300 });
  ScrollReveal().reveal('#carouselExampleIndicators', { delay: 300 });
  ScrollReveal().reveal('.gifts', { delay: 300 });
}

simplyCountdown(countdown, {
  year: 2024, // required
  month: 5, // required
  day: 11, // required
  hours: 18, // Default is 0 [0-23] integer
  minutes: 30, // Default is 0 [0-59] integer
  seconds: 0, // Default is 0 [0-59] integer
  words: {
    //words displayed into the countdown
    days: { singular: 'Día', plural: 'Días' },
    hours: { singular: 'Hora', plural: 'Horas' },
    minutes: { singular: 'Minuto', plural: 'Minutos' },
    seconds: { singular: 'Segundo', plural: 'Segundos' },
  },
  plural: true, //use plurals
  inline: false, //set to true to get an inline basic countdown like : 24 days, 4 hours, 2 minutes, 5 seconds
  inlineClass: 'simply-countdown-inline', //inline css span class in case of inline = true
  // in case of inline set to false
  enableUtc: false,
  onEnd: function () {
    // your code
    return;
  },
  refresh: 1000, //default refresh every 1s
  sectionClass: 'simply-section', //section css class
  amountClass: 'simply-amount', // amount css class
  wordClass: 'simply-word', // word css class
  zeroPad: false,
  countUp: false, // enable count up if set to true
});

function desplegarCantidadPersonas() {
  const si = document.getElementById('si');
  const no = document.getElementById('no');
  const select = document.querySelector('.select');

  si.addEventListener('click', function () {
    if (select.classList.contains('d-none')) {
      select.classList.remove('d-none');
    }
  });

  no.addEventListener('click', function () {
    select.classList.add('d-none');
  });
}

function esconderHeader() {
  window.onscroll = function () {
    let Desplazamiento_Actual = window.pageYOffset;
    if (ubicacionPrincipal >= Desplazamiento_Actual) {
      reproductor.classList.remove('d-none');
    } else {
      reproductor.classList.add('d-none');
    }
    ubicacionPrincipal = Desplazamiento_Actual;
  };
}

function bloquearScroll() {
  if (documento) {
    documento.classList.add('bloqueaScroll');
  }
}

function validarFormulario() {
  for (const radioButton of radioButtons) {
    radioButton.addEventListener('click', function () {
      if (radioButton.checked) {
        boton.removeAttribute('disabled');
      }
    });
  }

  formulario.addEventListener('submit', function (e) {
    e.preventDefault();

    var datos = new FormData(formulario);
    fetch('post.php', {
      method: 'POST',
      body: datos,
    })
      .then((respuesta) => respuesta.json())
      .then((data) => {
        console.log(data.qr);
        if (data === 'error') {
          Swal.fire({
            title: '<span class="alerta">Error<span>',
            text: 'Lo sentimos tus datos no se enviaron correctamente, trata nuevamente',
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });
        } else {
          Swal.fire({
            title: '<span class="alerta">¡Gracias!<span>',
            text: 'Tus datos han sido enviados correctamente',
            icon: 'success',
            confirmButtonText: 'Aceptar',
          });
        }
        if (radioButtons[0].checked) {
          preguntaConfirmacion.classList.add('d-none');

          if (paquete != 3) {
            formText.innerHTML = `<div class="contenido-form" id="aceptaConfirmacion">
            <h2>!Agradecemos mucho tu confirmación! Te esperamos</h2>
      
            </div>`;
          } else {
            formText.innerHTML = `<div class="contenido-form" id="aceptaConfirmacion">
            <h2>¡Agradecemos mucho tu confirmación! Te esperamos</h2>
      
            <p class="fs-5">Código de Confirmación QR</p>

            <div class="d-flex justify-content-center align-items-center">
              <div class="contenedor-qr">
                <img class="qr" src="qr/${token}.png" alt="qr">
              </div>
            </div>
            </div>`;
          }
        } else if (radioButtons[1].checked) {
          preguntaConfirmacion.classList.add('d-none');
          formText.innerHTML = `<div class="contenido-form" id="rechazaConfirmacion">
          <h2>Lamentamos que no puedas asistir, pero agradacemos tu confirmación</h2>
        </div>`;
        }
      });
  });
}

if (desbloquear) {
  desbloquear.addEventListener('click', function () {
    documento.classList.remove('bloqueaScroll');
    bienvenida.classList.remove('bienvenida-color');
    bienvenida.classList.add('d-none');

    audio.play();
  });
}

function botonCalendario1() {
  const config = {
    name: 'Boda de Lucía y Alejandro',
    description: '',
    startDate: '2024-5-11',
    endDate: '2024-5-11',
    options: ['Google', 'Apple'],
    timeZone: 'America/Tijuana',
    startTime: '18:00',
    endTime: '18:30',
    trigger: 'click',
    iCalFileName: 'Reminder-Event',
  };

  agendar1.addEventListener('click', () => atcb_action(config, agendar1));
}

function botonCalendario2() {
  const config = {
    name: 'Boda de Lucía y Alejandro',
    description: '',
    startDate: '2024-5-11',
    endDate: '2024-5-11',
    options: ['Google', 'Apple'],
    timeZone: 'America/Tijuana',
    startTime: '18:00',
    endTime: '18:30',
    trigger: 'click',
    iCalFileName: 'Reminder-Event',
  };

  agendar2.addEventListener('click', () => atcb_action(config, agendar2));
}
